import * as React from "react";
import { UserContext } from "../contexts/user";
import { useParams } from "react-router-dom";
import { useContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Box,
  Snackbar,
  Tab,
  Chip,
  Typography,
  Button,
  Table,
  TableCell,
  TableRow,
  Grid,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import LoadingButton from "@mui/lab/LoadingButton";
import EditAdminUserForm from "../components/Forms/EditAdminUserForm";
import Loading from "./Loading";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import KeyIcon from "@mui/icons-material/Key";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MuiAlert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import PageTitles from "../components/Layout/PageTitles";
import LogsTable from "../components/Tables/LogsTable";

const AdminUserAccount = () => {
  const currentAdmin = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [adminUserData, setAdminUserData] = useState([]);
  const [adminUserError, setAdminUserError] = useState(null);
  const { adminUser } = useParams();
  const [value, setValue] = useState("1");
  const [password, setPassword] = useState("********");
  const [expanded, setExpanded] = useState(false);
  const [passwordBtn, setPasswordBtn] = useState(false);
  const [adminUserUpdated, setAdminUserUpdated] = useState();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [alertColour, setAlertColour] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`/adminUserRec/${adminUser}`)
      .then((res) => {
        let resData = res.data.adminUser
        setAdminUserData(resData);
      })
      .then(() => {
        if (adminUserData) {
          setIsLoading(false);
        }
      })
      .catch((err) => {   
        setAdminUserError(err.response);
      });
  }, [adminUserUpdated]);

  //optimisting rendering alert for reset password and edit user

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleAccordianChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const getPassword = (event) => {
    setBtnLoading(true);
    axios
      .get("/get_password")
      .then((res) => {
        setPassword(res.data.password);
      })
      .then(() => {
        setBtnLoading(false);
        setPasswordBtn(!passwordBtn);
      });
  };

  const savePassword = (event) => {
    event.preventDefault();
    let password = event.target[0].value;
    axios
      .patch("/admin_new_password", { password: password, admin_username: adminUser })
      .then((res) => {
        setAlertColour("success");
        setMessage(res.data);
        setExpanded(false);
        setPasswordBtn(false);
        setOpen(true);
      })

      .catch((err) => {
        setAlertColour("error");
        setMessage(err.response.data);
        setOpen(true);
      });
  };

  const handleDeleteAdmin = (adminUser) => {
    axios
      .delete(`/delete_admin_user/${adminUser}`)
      .then((res) => {
        setAlertColour("success");
        setMessage(res.data);
        setOpen(true);
      })
      .then(() => {
        setTimeout(() => {
          navigate(`/admin_users`);
        }, "3000");
      })
      .catch((err) => {
        setAlertColour("error");
        setMessage(err.response.data);
        setOpen(true);
      });

    // axios.delete(`/delete_admin_user/${adminUser}`).then(() => {
    //   navigate(`/admin_users`);
    // });

  };

  if (adminUserError) {
    return <h1> No admin user </h1>;
  }

  return (
    <Box>
      <PageTitles title={"Admin User details"} />
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "#212121",
            fontWeight: "bold",
          }}
        >
          <TabList onChange={handleTabChange} aria-label="lab API tabs example">
            <Tab label="Account Details" value="1" />
            <Tab label="Logs" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          {isLoading && <Loading />}
          {isLoading === false && (
            <>
              <Typography
                color="primary"
                variant="h3"
                sx={{
                  mb: "20px",
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                {" "}
                <AccountCircleIcon sx={{ mr: "10px", fontSize: "1em" }} />{" "}
                {adminUserData.firstName} {adminUserData.lastName} &#40;{" "}
                {adminUserData.username} &#41;{" "}
              </Typography>

              <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleAlertClose}
              >
                {
                  <Alert
                    onClose={handleAlertClose}
                    severity={alertColour}
                    sx={{ width: "100%" }}
                  >
                    {message}
                  </Alert>
                }
              </Snackbar>

              <Box sx={{ display: "flex", mb: "20px" }}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5"> Account details</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        "& .tableHeader": {
                          color: "#A020F0",
                          fontWeight: "Bold",
                          fontSize: "1em",
                        },
                      }}
                    >
                      <Table
                        sx={{
                          backgroundColor: "#212121",
                          mt: "20px",
                          p: "5px",
                        }}
                      >
                        <tbody>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Name
                            </TableCell>
                            <TableCell>
                              <Typography>
                                {adminUserData.firstName + " " + adminUserData.lastName}
                              </Typography>
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Account status
                            </TableCell>
                            <TableCell>
                              {adminUserData.state === "Active" && (
                                <Chip
                                  label={adminUserData.state}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#4caf50",
                                    ml: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                              {adminUserData.state !== "Active" && (
                                <Chip
                                  label={adminUserData.state}
                                  sx={{
                                    fontWeight: "Bold",
                                    backgroundColor: "#f44336",
                                    ml: "5px",
                                    fontSize: "1em",
                                  }}
                                />
                              )}
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              Email
                            </TableCell>
                            <TableCell>
                              <Typography>{adminUserData.email}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell variant="head" className="tableHeader">
                              MFA ?
                            </TableCell>
                            <TableCell>
                              {adminUserData.mfaKey == null && (
                                <Typography
                                  sx={{
                                    flexShrink: 0,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {" "}
                                  <CancelRoundedIcon
                                    fontSize="small"
                                    sx={{ color: "#f44336", mr: "5px" }}
                                  />
                                  Not enabled
                                </Typography>
                              )}
                              {adminUserData.mfaKey !== null && adminUserData.mfaKey}
                            </TableCell>
                          </TableRow>
                        </tbody>
                      </Table>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              <Box>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleAccordianChange("panel1")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography
                      sx={{
                        width: "70%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {" "}
                      <PersonOutlineIcon sx={{ mr: "10px" }} />
                      Edit admin user details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {expanded === "panel1" && (
                      <EditAdminUserForm
                        setExpanded={setExpanded}
                        setAdminUserUpdated={setAdminUserUpdated}
                        setAdminUserError={setAdminUserError}
                        setOpen={setOpen}
                        setMessage={setMessage}
                        setAlertColour={setAlertColour}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleAccordianChange("panel2")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                  >
                    <Typography
                      sx={{
                        width: "70%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {" "}
                      <KeyIcon sx={{ mr: "10px" }} /> Reset admin user's password
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        mt: "5px",
                        mb: "5px",
                        backgroundColor: "#212121",
                        p: "20px",
                        display: "flex",
                        alignItems: "end",
                      }}
                    >
                      <form onSubmit={savePassword}>
                        <TextField value={password} readOnly={true} />

                        {passwordBtn === false && (
                          <LoadingButton
                            variant="contained"
                            size="medium"
                            loading={btnLoading}
                            sx={{
                              ml: "10px",
                              mr: "10px",
                              mt: "10px",
                              mb: "10px",
                              backgroundColor: "#2196f3",
                              "&:hover": { backgroundColor: "#0d47a1" },
                            }}
                            onClick={getPassword}
                          >
                            create a new password
                          </LoadingButton>
                        )}
                        {passwordBtn === true && (
                          <Button
                            type="submit"
                            value="Submit"
                            size="medium"
                            sx={{
                              ml: "10px",
                              mr: "10px",
                              mt: "10px",
                              mb: "10px",
                              color: "#121212",
                              backgroundColor: "#ce93d8",
                              "&:hover": { backgroundColor: "#a441b4" },
                              p: "5px",
                            }}
                          >
                            Submit
                          </Button>
                        )}
                      </form>
                    </Box>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleAccordianChange("panel4")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                  >
                    <Typography
                      sx={{
                        width: "70%",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {" "}
                      <DeleteIcon sx={{ mr: "10px" }} /> Delete admin user
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        mt: "5px",
                        backgroundColor: "#212121",
                        display: "flex",
                        padding: "20px",
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => {
                          handleDeleteAdmin(adminUser);
                        }}
                        sx={{
                          ml: "10px",
                          maxHeight: "30px",
                          backgroundColor: "#ff3d00",
                          "&:hover": { backgroundColor: "#dd2c00" },
                        }}
                      >
                        Delete admin user: {adminUser}
                      </Button>{" "}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>
            </>
          )}
        </TabPanel>
        <TabPanel value="2">
        
        <LogsTable username={'[adm]'+adminUser}/>
        
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default AdminUserAccount;
